import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { PERFIL_ADMIN, getAdminEmpresa, getFinanceiroEmpresa } from '../../security/securityContext'
import Autorizacao, { validaPerfis } from '../../security/Autorizacao'
import DatePicker from 'react-datepicker/es'
import { renderFieldSelect, requiredSelect } from '../../util/inputs'
import buscarDadosVexadoBI from '../../actions/vexado-bi/buscarDadosVexadoBI'
import limparDadosVexadoBI from '../../actions/vexado-bi/limparDadosVexadoBI'
import { formatarReal } from '../../util/numberUtil'
import GraficoVendasPorDiaMesAno from './GraficoVendasPorDiaMesAno'
import GraficoTopBilheteiros from './GraficoTopBilheteiros'
import GraficoPorRotas from './GraficoPorRotas'
import GraficoPorEmpresaAgencia from './GraficoPorEmpresaAgencia'
import { TIPO_RELATORIO, GRUPOS, ITEM_TODAS_EMPRESAS, tipoRelatorio } from '../../util/constantsUtil'
import Select from 'react-select'
import buscarEmpresas from '../../actions/empresa/buscarEmpresas'
import GraficoTodasEmpresas from './GraficoTodasEmpresas'
import GraficoPorTrechos from './GraficoPorTrecho'
import GraficoPorVeiculo from './GraficoPorVeiculo'
import GraficoPorTipoPagamento from './GraficoPorTipoPagamento'
import GraficoPorTipoEmissao from './GraficoPorTipoEmissao'
import GraficoPorTipoTarifa from './GraficoPorTipoTarifa'
import GraficoPorBagagem from './GraficoPorBagagem'
import GraficoPorCentroCusto from './GraficoPorCentroCusto'
import GraficoPorOcorrencia from './GraficoPorOcorrencia'
import GraficoPorEncomendas from './GraficoPorEncomendas'
import GraficoPorFechamentoCaixa from './GraficoPorFechamentoCaixa'
import GraficoPorSeguro from './GraficoPorSeguro'

/* ── KPI Card ── */
const KpiCard = ({ label, valor, iconName, iconColor, iconBg }) => (
  <div className="vx-kpi-card">
    <div className="vx-kpi-card-top">
      <span className="vx-kpi-label">{label}</span>
      <div className="vx-kpi-icon" style={{ background: iconBg }}>
        <i className="material-icons" style={{ color: iconColor, fontSize: '15px' }}>{iconName}</i>
      </div>
    </div>
    <div className="vx-kpi-value">{valor}</div>
    <div className="vx-kpi-change neutral">período selecionado</div>
  </div>
)

/* ── Chart Card wrapper ── */
const ChartCard = ({ titulo, children }) => (
  <div className="vx-chart-card">
    <div className="vx-chart-card-top">
      <h6 className="vx-chart-title">{titulo}</h6>
    </div>
    {children}
  </div>
)

const labelStyle = {
  fontSize: 11, color: '#999', fontWeight: 600,
  textTransform: 'uppercase', letterSpacing: 0.4,
  marginBottom: 4, display: 'block',
}

export class PainelVexadoBI extends React.Component {

  constructor (props) {
    super(props)
    this.expandir = this.expandir.bind(this)
    this._mounted = false
    this.state = {
      tipoRelatorio: null,
      empresasSelecionadas: [],
      gruposSelecionados: [],
      dataInicio: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      dataFim: new Date(),
      graficoSelecionado: '',
      carregando: false,
      chartRenderKey: 0,
    }
  }

  componentDidMount () {
    this._mounted = true
    if (this.naoEhPerfilAdmin()) {
      this.setState({
        tipoRelatorio: tipoRelatorio.empresa,
        empresasSelecionadas: [{ label: this.props.empresaSelecionada.nomeFantasia, value: this.props.empresaSelecionada.id }],
      })
      this.props.buscarEmpresas(this.props.empresaSelecionada.id)
    } else {
      this.props.buscarEmpresas()
    }
    this.props.limparDadosVexadoBI()
    this.setState({ carregando: true })
    this.props.buscarDadosVexadoBI(
      this.props.empresaSelecionada.id,
      this.state.dataInicio,
      this.state.dataFim,
      null, null,
      true,
      false
    ).then(() => {
      if (!this._mounted) return
      this.setState({ carregando: false })
      // Remount dos charts 200ms após dados chegarem: garante que o browser
      // já calculou o layout Flexbox (offsetWidth > 0 quando draw() é chamado).
      setTimeout(() => {
        if (this._mounted) this.setState(s => ({ chartRenderKey: s.chartRenderKey + 1 }))
      }, 200)
    }).catch(() => {
      if (this._mounted) this.setState({ carregando: false })
    })
  }

  componentWillUnmount () {
    this._mounted = false
  }

  naoEhPerfilAdmin () { return !this.ehPerfilAdmin() }
  ehPerfilAdmin ()    { return validaPerfis([PERFIL_ADMIN]) }

  retornaTodasEmpresas () {
    const empresasMapeadas = this.props.empresas.map(e => ({ label: e.nomeFantasia, value: e.id }))
    return [...empresasMapeadas, ITEM_TODAS_EMPRESAS]
  }

  exibirComboEmpresas () {
    return (
      <Select
        noOptionsMessage={() => 'Nenhuma opção encontrada'}
        value={this.state.empresasSelecionadas}
        isMulti
        placeholder='Selecione...'
        styles={{ control: base => ({ ...base, minHeight: 34, fontSize: 13, borderColor: '#e4e7ea', cursor: 'pointer' }) }}
        options={this.retornaTodasEmpresas()}
        onChange={ev => this.setState({ empresasSelecionadas: [...ev] })}
      />
    )
  }

  exibirComboGrupos () {
    return (
      <Select
        noOptionsMessage={() => 'Nenhuma opção encontrada'}
        value={this.state.gruposSelecionados}
        isMulti
        placeholder='Selecione...'
        styles={{ control: base => ({ ...base, minHeight: 34, fontSize: 13, borderColor: '#e4e7ea', cursor: 'pointer' }) }}
        options={GRUPOS}
        onChange={ev => this.setState({ gruposSelecionados: [...ev] })}
      />
    )
  }

  getGruposSelectedValues = (selectedItems, allLabel, defaultValues) => {
    if (selectedItems.map(it => it.value).includes(allLabel)) {
      return defaultValues.filter(it => !['TODOS', 'SEM_GRUPO'].includes(it.value)).map(it => it.value).join(',')
    }
    if (selectedItems.map(it => it.value).includes('SEM_GRUPO')) {
      return selectedItems.filter(it => it.value !== 'SEM_GRUPO').map(it => it.value).join(',')
    }
    return selectedItems.map(it => it.value).join(',')
  }

  getEmpresasSelectedValues = (selectedItems, allLabel, defaultValues) => {
    if (selectedItems.map(it => it.label).includes(allLabel)) {
      return defaultValues.map(it => it.id).join(',')
    }
    return selectedItems.map(it => it.value).join(',')
  }

  getGruposOuEmpresas = () => {
    const { gruposSelecionados, empresasSelecionadas } = this.state
    let grupos = null, empresas = null, empresasSemGrupo = false
    if (this.state.tipoRelatorio === tipoRelatorio.grupo) {
      grupos = this.getGruposSelectedValues(gruposSelecionados, 'TODOS', GRUPOS)
      empresasSemGrupo = gruposSelecionados.map(it => it.value).includes('SEM_GRUPO')
    }
    if (this.state.tipoRelatorio === tipoRelatorio.empresa) {
      empresas = this.getEmpresasSelectedValues(empresasSelecionadas, 'TODAS', this.props.empresas)
    }
    return { grupos, empresas, empresasSemGrupo }
  }

  buscar () {
    const { grupos, empresas, empresasSemGrupo } = this.getGruposOuEmpresas()
    this.setState({ carregando: true })
    this.props.buscarDadosVexadoBI(
      this.props.empresaSelecionada.id,
      this.state.dataInicio,
      this.state.dataFim,
      empresas, grupos,
      this.state.empresasSelecionadas.length <= 1,
      empresasSemGrupo
    ).then(() => {
      if (!this._mounted) return
      this.setState({ carregando: false })
      setTimeout(() => {
        if (this._mounted) this.setState(s => ({ chartRenderKey: s.chartRenderKey + 1 }))
      }, 200)
    }).catch(() => {
      if (this._mounted) this.setState({ carregando: false })
    })
  }

  expandir (tipo) {
    this.setState({ graficoSelecionado: tipo })
  }

  exibirGraficoDadoTipoSelecionado () {
    const { graficoSelecionado, empresasSelecionadas, dataInicio, dataFim } = this.state
    let grafico = null
    switch (graficoSelecionado) {
      case 'rota':           grafico = <GraficoPorRotas full={true} />; break
      case 'empresaAgencia': grafico = <GraficoPorEmpresaAgencia agenciaHabilitado={empresasSelecionadas.length <= 1} full={true} />; break
      case 'diaMes':         grafico = <GraficoVendasPorDiaMesAno full={true} />; break
      case 'vendedor':       grafico = <GraficoTopBilheteiros full={true} dataInicio={dataInicio} dataFim={dataFim} getGruposOuEmpresas={this.getGruposOuEmpresas} empresaSelecionadaId={this.props.empresaSelecionada.id} />; break
      case 'empresas':       grafico = <GraficoTodasEmpresas full={true} />; break
      case 'trecho':         grafico = <GraficoPorTrechos full={true} />; break
      case 'veiculo':        grafico = <GraficoPorVeiculo full={true} />; break
      case 'tipoPagamento':  grafico = <GraficoPorTipoPagamento full={true} />; break
      case 'tipoEmissao':    grafico = <GraficoPorTipoEmissao full={true} />; break
      case 'tipoTarifa':     grafico = <GraficoPorTipoTarifa full={true} />; break
      case 'bagagem':        grafico = <GraficoPorBagagem full={true} />; break
      case 'centroCusto':    grafico = <GraficoPorCentroCusto full={true} />; break
      case 'ocorrencia':     grafico = <GraficoPorOcorrencia full={true} />; break
      case 'encomendas':     grafico = <GraficoPorEncomendas full={true} />; break
      case 'fechamentoCaixa': grafico = <GraficoPorFechamentoCaixa full={true} />; break
      case 'seguro':         grafico = <GraficoPorSeguro full={true} />; break
      default:               return null
    }
    // wrapper garante width:100% no contexto do overlay flex (position:fixed)
    return <div style={{ width: '100%', display: 'block' }}>{grafico}</div>
  }

  exibirGraficoExpandido () {
    return (
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,15,15,0.65)', zIndex: 1050, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '32px 24px', overflowY: 'auto' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: '100%', maxWidth: 1200 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
            <h5 style={{ margin: 0, fontWeight: 700, color: '#0F0F0F' }}>Visualização ampliada</h5>
            <button
              onClick={() => this.setState({ graficoSelecionado: '' })}
              style={{ background: 'none', border: '1px solid #e0e0e0', borderRadius: 8, padding: '6px 14px', fontSize: 13, cursor: 'pointer', color: '#666', display: 'flex', alignItems: 'center', gap: 6 }}
            >
              <i className="material-icons" style={{ fontSize: 16 }}>close</i>
              Fechar
            </button>
          </div>
          {this.exibirGraficoDadoTipoSelecionado()}
        </div>
      </div>
    )
  }

  render () {
    const { handleSubmit, submitting, invalid } = this.props
    const bi = this.props.vexadoBI || {}
    const { dataInicio, dataFim, tipoRelatorio: tr, empresasSelecionadas, gruposSelecionados, carregando, chartRenderKey } = this.state

    const buscarDisabled = invalid || submitting || !dataInicio || !dataFim
      || (tr === 'GRUPO'   && !gruposSelecionados.length)
      || (tr === 'EMPRESA' && !empresasSelecionadas.length)

    const fmt = v => formatarReal((v || '0').toString())

    if (this.state.graficoSelecionado) return this.exibirGraficoExpandido()

    return (
      <Autorizacao
        perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id), getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}
        empresaSelecionada={this.props.empresaSelecionada}
      >
        <div style={{ padding: '24px', maxWidth: 1400, margin: '0 auto' }}>

          {/* ── Header ── */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, background: 'rgba(255,106,0,0.10)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <i className="material-icons" style={{ color: '#FF6A00', fontSize: 24 }}>equalizer</i>
            </div>
            <div>
              <h4 style={{ margin: 0, fontWeight: 700, color: '#0F0F0F', fontSize: 20, lineHeight: 1.2 }}>VexBI</h4>
              <span style={{ fontSize: 12, color: '#aaa' }}>Dashboard analítico de vendas</span>
            </div>
          </div>

          {/* ── Filtros ── */}
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #f0f0f0', padding: '16px 20px', marginBottom: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
            <form onSubmit={handleSubmit(this.buscar.bind(this))}>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, flexWrap: 'wrap' }}>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={labelStyle}>De</span>
                  <DatePicker
                    selected={dataInicio}
                    onChange={date => this.setState({ dataInicio: date })}
                    className='form-control form-control-sm'
                    locale="pt-BR"
                    dateFormat="dd/MM/yyyy"
                    maxDate={dataFim}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={labelStyle}>Até</span>
                  <DatePicker
                    selected={dataFim}
                    onChange={date => this.setState({ dataFim: date })}
                    className='form-control form-control-sm'
                    locale="pt-BR"
                    dateFormat="dd/MM/yyyy"
                    minDate={dataInicio}
                    maxDate={new Date()}
                  />
                </div>

                {this.ehPerfilAdmin() && (
                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: 190 }}>
                    <span style={labelStyle}>Tipo de relatório</span>
                    <Field
                      name='tipoRelatorio'
                      options={TIPO_RELATORIO}
                      onChange={ev => this.setState({ tipoRelatorio: ev.value })}
                      component={renderFieldSelect}
                      placeholder='Selecione...'
                      validate={requiredSelect}
                    />
                  </div>
                )}

                {tr === tipoRelatorio.grupo && (
                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: 220, flex: 1 }}>
                    <span style={labelStyle}>Grupo</span>
                    <Field id='grupo' name='grupo' component={this.exibirComboGrupos.bind(this)} />
                  </div>
                )}

                {tr === tipoRelatorio.empresa && (
                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: 220, flex: 1 }}>
                    <span style={labelStyle}>Empresa</span>
                    <Field id='empresa' name='empresa' component={this.exibirComboEmpresas.bind(this)} />
                  </div>
                )}

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ ...labelStyle, color: 'transparent' }}>x</span>
                  <button
                    type="submit"
                    disabled={buscarDisabled}
                    style={{
                      height: 34, padding: '0 18px',
                      background: buscarDisabled ? '#e0e0e0' : '#FF6A00',
                      color: buscarDisabled ? '#aaa' : '#fff',
                      border: 'none', borderRadius: 6, fontWeight: 600, fontSize: 13,
                      cursor: buscarDisabled ? 'not-allowed' : 'pointer',
                      display: 'flex', alignItems: 'center', gap: 6, transition: 'background 0.15s',
                    }}
                  >
                    <i className="material-icons" style={{ fontSize: 16 }}>search</i>
                    {carregando ? 'Buscando...' : 'Buscar'}
                  </button>
                </div>

              </div>
            </form>
          </div>

          {/* ── KPIs ── */}
          <div className="vx-kpi-grid" style={{ marginBottom: 24 }}>
            <KpiCard label="Faturamento Total"  valor={fmt(bi.valorTotalFaturamento)}  iconName="attach_money"   iconColor="#28a745" iconBg="rgba(40,167,69,0.10)" />
            <KpiCard label="Cancelamento Total" valor={fmt(bi.valorTotalCancelamento)} iconName="cancel"          iconColor="#dc3545" iconBg="rgba(220,53,69,0.10)" />
            <KpiCard label="Líquido Total"      valor={fmt(bi.valorTotalLiquido)}      iconName="account_balance" iconColor="#17a2b8" iconBg="rgba(23,162,184,0.10)" />
            <KpiCard label="Imposto Líquido"    valor={fmt(bi.valorTotalImposto)}      iconName="receipt"         iconColor="#6f42c1" iconBg="rgba(111,66,193,0.10)" />
            <KpiCard label="Ticket Médio"       valor={fmt(bi.valorTotalTicketMedio)}  iconName="local_atm"       iconColor="#FF6A00" iconBg="rgba(255,106,0,0.10)" />
          </div>

          {/* ── Gráficos — linha 1 ── */}
          <div className="vx-charts-row">
            <ChartCard titulo="Faturamento por rota">
              <GraficoPorRotas key={'rota-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
            <ChartCard titulo={empresasSelecionadas.length <= 1 ? 'Faturamento por agência' : 'Faturamento por empresa'}>
              <GraficoPorEmpresaAgencia key={'ea-' + chartRenderKey} expandir={this.expandir} agenciaHabilitado={empresasSelecionadas.length <= 1} />
            </ChartCard>
          </div>

          {/* ── Gráficos — linha 2 ── */}
          <div className="vx-charts-row">
            <ChartCard titulo="Vendas por dia / mês / ano">
              <GraficoVendasPorDiaMesAno key={'dia-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
            <ChartCard titulo="Top bilheteiros">
              <GraficoTopBilheteiros
                key={'vend-' + chartRenderKey}
                expandir={this.expandir}
                dataInicio={dataInicio}
                dataFim={dataFim}
                getGruposOuEmpresas={this.getGruposOuEmpresas}
                empresaSelecionadaId={this.props.empresaSelecionada.id}
              />
            </ChartCard>
          </div>

          {/* ── Gráficos — linha 3 ── */}
          <div className="vx-charts-row">
            <ChartCard titulo="Comparativo de empresas">
              <GraficoTodasEmpresas key={'emp-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
            <ChartCard titulo="Faturamento por trecho">
              <GraficoPorTrechos key={'trecho-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
          </div>

          {/* ── Gráficos — linha 4 ── */}
          <div className="vx-charts-row">
            <ChartCard titulo="Faturamento por veículo">
              <GraficoPorVeiculo key={'vei-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
            <ChartCard titulo="Vendas por Tipo de Pagamento">
              <GraficoPorTipoPagamento key={'tpag-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
          </div>

          {/* ── Gráficos — linha 5 ── */}
          <div className="vx-charts-row">
            <ChartCard titulo="Vendas por Tipo de Emissão de Reserva">
              <GraficoPorTipoEmissao key={'temis-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
            <ChartCard titulo="Faturamento por Tipo de Tarifa">
              <GraficoPorTipoTarifa key={'ttarifa-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
          </div>

          {/* ── Gráficos — linha 6 ── */}
          <div className="vx-charts-row">
            <ChartCard titulo="Venda de Excesso de Bagagem">
              <GraficoPorBagagem key={'bag-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
            <ChartCard titulo="Venda de Encomendas">
              <GraficoPorEncomendas key={'encom-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
          </div>

          {/* ── Gráficos — linha 7 ── */}
          <div className="vx-charts-row">
            <ChartCard titulo="Fechamento de Caixa por Situação">
              <GraficoPorFechamentoCaixa key={'fcaixa-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
            <ChartCard titulo="Venda de Seguro">
              <GraficoPorSeguro key={'seg-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
          </div>

          {/* ── Gráficos — linha 8 ── */}
          <div className="vx-charts-row">
            <ChartCard titulo="Centro de Custo por Tipo">
              <GraficoPorCentroCusto key={'cc-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
            <ChartCard titulo="Tipo de Ocorrência / Centro de Custo">
              <GraficoPorOcorrencia key={'ocorr-' + chartRenderKey} expandir={this.expandir} />
            </ChartCard>
          </div>

        </div>
      </Autorizacao>
    )
  }
}

export function mapStateToProps (state) {
  return {
    empresas: state.empresas,
    empresaSelecionada: state.empresaSelecionada,
    vexadoBI: state.vexadoBI,
  }
}

export default connect(mapStateToProps, {
  buscarDadosVexadoBI,
  limparDadosVexadoBI,
  buscarEmpresas,
})(reduxForm({
  form: 'formularioVexadoBI',
})(PainelVexadoBI))
